import bluebird from 'bluebird'
import transitionPath from 'router5-transition-path'
import findRoutes from '../utils/findRoutes'


const runTriggers = async ({
  routes,
  params,
  fromParams,
  store,
  propName,
}) => {
  const allTriggers = routes.reduce((all, route) => {
    let triggers = route.trigger || {}
    const toRun = triggers[propName]
    if(!toRun) return all
    if(typeof(toRun) === 'function') triggers = [toRun]
    return all.concat(toRun)
  }, [])

  await bluebird.each(allTriggers, async trigger => await trigger(store, params, fromParams))
}

/*

  trigger actions when routes become active

*/
const triggerRoute = (routes) => (router, dependencies) => async (toState, fromState, done) => {

  const { toActivate, toDeactivate, intersection } = transitionPath(toState, fromState)
  const { store } = dependencies
  const params = toState.params
  const fromParams = fromState ? fromState.params : {}

  const intersectionRoutes = intersection ? findRoutes(routes, [intersection]) : []
  const activeRoutes = findRoutes(routes, toActivate)
  const deactiveRoutes = findRoutes(routes, toDeactivate)

  await runTriggers({
    routes: intersectionRoutes,
    params: fromParams,
    fromParams,
    store,
    propName: 'deactivate',
  })

  await runTriggers({
    routes: intersectionRoutes,
    params,
    fromParams,
    store,
    propName: 'activate',
  })
  
  await runTriggers({
    routes: deactiveRoutes,
    params,
    fromParams,
    store,
    propName: 'deactivate',
  })

  await runTriggers({
    routes: activeRoutes,
    params,
    fromParams,
    store,
    propName: 'activate',
  })

  done()
}

export default triggerRoute